<template>
  <div class="slide-show" @mouseover="clearInv" @mouseout="runInv">
    <div class="slide-img">
<!--      <a :href="slides[nowIndex].href">-->
        <transition name="slide-trans">
          <img v-if="isShow" :src="slides[nowIndex].src">
        </transition>
        <transition name="slide-trans-old">
          <img v-if="!isShow" :src="slides[nowIndex].src">
        </transition>
<!--      </a>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      default: []
    },
    inv: {
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      nowIndex: 0,
      isShow: true
    }
  },
  computed: {
    prevIndex () {
      if (this.nowIndex === 0) {
        return this.slides.length - 1
      }
      else {
        return this.nowIndex - 1
      }
    },
    nextIndex () {
      if (this.nowIndex === this.slides.length - 1) {
        return 0
      }
      else {
        return this.nowIndex + 1
      }
    }
  },
  methods: {
    goto (index) {
      this.isShow = false
      setTimeout(() => {
        this.isShow = true
        this.nowIndex = index
      }, 10)
    },
    runInv () {
      this.invId = setInterval(() => {
        this.goto(this.nextIndex)
      }, this.inv)
    },
    clearInv () {
      clearInterval(this.invId)
    }
  },
  mounted () {
    this.runInv();
  }
}
</script>

<style scoped>
.slide-trans-enter-active {
  transition: all .3s;
}
.slide-trans-enter {
  transform: translateX(100%);
    /*transition: all .5s;*/
}
.slide-trans-old-leave-active {
  transition: all .5s;
  transform: translateX(-100%);
}
.slide-show {
  position: relative;
  /*margin: 15px 15px 15px 0;*/
  width: 100%;
  max-height: 475px ;
  overflow: hidden;
}
.slide-img {
  width: 100%;
  max-height: 475px;

}
.slide-img img {
  width: 100%;
   max-height: 475px;
}
</style>



// WEBPACK FOOTER //
// src/components/slideShow.vue